;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"82a6c7ca95be7d61ab53490314f791a25ad65681"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.4.3";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/plp";globalThis["_sentryAssetPrefix"] = "/plp";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:cacheKey\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"cacheKey\"],\"hasOptionalPrefix\":false},{\"path\":\"/:cacheKey/:slug*\",\"regex\":\"^/([^/]+)/(.+)$\",\"paramNames\":[\"cacheKey\",\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"}]}";import * as Sentry from '@sentry/nextjs';

const {
    sharedSentryReplayIntegrationConfig,
} = require('../../libs/common-next/shared-sentry.replayIntegration.config');

const { initSentry } = require('../../libs/common-next/shared-sentry.next.config');

initSentry({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

    initialScope: {
        tags: {
            application_name: 'PLP',
        },
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE) || 0.015,
    replaysSessionSampleRate: Number(process.env.NEXT_PUBLIC_REPLAYS_SESSION_SAMPLE_RATE) || 0.25,
    replaysOnErrorSampleRate: Number(process.env.NEXT_PUBLIC_REPLAYS_ON_ERROR_SAMPLE_RATE) || 1.0,

    // NOTE: the BrowserTracing and Replay was commented out to avoid performance issue
    integrations: [
        Sentry.captureConsoleIntegration({
            levels: ['error'],
        }),
        Sentry.replayIntegration(sharedSentryReplayIntegrationConfig),
        Sentry.httpClientIntegration(),
    ],
    sendDefaultPii: true,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

export default Sentry;
